import { useAppSelector } from '@redux/hooks';
import { Link } from '@tkww/orion-web-ds-action';
import { TextBody } from '@tkww/orion-web-ds-text';
import React, { useCallback } from 'react';

import {
	type StorefrontSection,
	useTrackStorefrontInteraction,
} from '@hooks/useTrackStorefrontInteraction';
import classnames from 'classnames';
import Styles from './EmptyStateSearchLink.scss';

export interface EmptyStateSearchLinkProps {
	header: string;
	text: string;
	linkText: 'Continue browsing vendors';
	storefrontSection: StorefrontSection;
	inline?: boolean;
}

export const EmptyStateSearchLink = ({
	header,
	text,
	linkText,
	storefrontSection,
	inline = true,
}: EmptyStateSearchLinkProps) => {
	const cityUrl = useAppSelector(
		(state) => state.vendor.vendor?.breadcrumbInfo?.cityUrl,
	);
	const track = useTrackStorefrontInteraction(storefrontSection);

	const onClickHandler = useCallback(() => {
		track(`${linkText} clicked`);
	}, [track, linkText]);

	if (!cityUrl) {
		return null;
	}

	return (
		<div className={Styles.emptyStateSearchLinkWrapper}>
			<div className={Styles.emptyStateSearchLink}>
				<TextBody size="md" bold className={Styles.emptyStateSearchHeader}>
					{header}
				</TextBody>
				<div
					className={classnames(Styles.emptyStateSearchContent, {
						[Styles.inline]: inline,
					})}
				>
					{text}
					<Link
						href={cityUrl}
						title={linkText}
						onClick={onClickHandler}
						className={Styles.cityLink}
					>
						{linkText}
					</Link>
				</div>
			</div>
		</div>
	);
};
